import React from 'react'
import { Platform } from 'react-native'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { BTN_LG } from '@zet/design-system'
import { Stack, YStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'
import { getName } from '@zet/utils/stringConversion'

import { REASON_LIST } from '../../utils/constants'
import WebApplyButton from '../productCard/webApplyButton'

const Footer = ({
  setIsBottomSheetVisible,
  navigate,
  brandId,
  isEligible,
  criteria,
  showShareButton = true,
  customerData,
  brandName,
  alreadyApplied,
  isSourceWeb,
  isInEligible,
  index,
  leadAdded,
  setIsExploreOtherCardsBSVisible,
  eligibleCardsCountExcludingMagnet,
  variantId,
}: {
  setIsBottomSheetVisible: React.Dispatch<React.SetStateAction<boolean>>
  setIsExploreOtherCardsBSVisible?: React.Dispatch<
    React.SetStateAction<boolean>
  >
  navigate: unknown
  brandId: string | number
  isEligible?: boolean
  criteria?: string
  showShareButton?: boolean
  customerData: {
    id?: number
    name?: string
    phoneNumber?: string | number
  }
  brandName: string
  alreadyApplied?: boolean
  isSourceWeb?: boolean
  isInEligible?: boolean
  index: number
  leadAdded?: boolean
  eligibleCardsCountExcludingMagnet?: number
  variantId?: string | number
}) => {
  const isWeb = Platform.OS === 'web'
  const RenderButton = ({ criteria }: { criteria?: string }) => {
    if (
      isWeb &&
      !REASON_LIST.includes(criteria as string) &&
      APP_NAME !== MY_TEAMS_ADVISOR
    ) {
      return (
        <WebApplyButton
          partnerId={brandId as string}
          alreadyApplied={alreadyApplied as boolean}
          isSourceWeb={isSourceWeb as boolean}
          isInEligible={isInEligible as boolean}
          customerId={customerData?.id}
          index={index}
          customerPhoneNumber={customerData?.phoneNumber}
          leadAdded={leadAdded}
          customerName={customerData?.name}
          setIsBottomSheetVisible={setIsBottomSheetVisible}
          setIsExploreOtherCardsBSVisible={setIsExploreOtherCardsBSVisible}
          eligibleCardsCountExcludingMagnet={eligibleCardsCountExcludingMagnet}
          variantId={variantId}
        />
      )
    } else if (!REASON_LIST.includes(criteria)) {
      return (
        <Stack className="mt-2 px-3">
          <Pressable
            fullWidth
            size={'lg'}
            className="bg-primary-100 mt-2 items-center justify-center rounded-md border-none px-2 py-3"
            onPress={() => {
              setIsBottomSheetVisible(false)
              navigate('ShareCardLink', {
                brandId: brandId,
                customerName: getName(customerData?.name),
                customerPhoneNumber: customerData?.phoneNumber,
                customerId: customerData?.id,
                isEligibleBrand: !!isEligible,
                eventName: 'click_action',
                eventPayload: {
                  item_name: 'brands_list_recommendation_share',
                  brand_name: brandName,
                  customer_id: customerData?.id,
                },
                variantId,
              })
            }}
            eventName="click_action"
            eventPayload={{
              item_name: isEligible
                ? 'recommendation_app_flow_sell_to_customer'
                : 'recommendation_app_flow_sell_anyways',
              customerId: customerData?.id,
              customerName: customerData?.name,
              customerPhoneNumber: customerData?.phoneNumber,
              isEligible: !!isEligible,
              brandId: brandId,
            }}
          >
            <BTN_LG className="text-white">
              {isWeb
                ? i18n.t('eligiblecustomers.cta')
                : isEligible
                ? i18n.t('recommendationBottomSheet.sellButton', {
                    name: getName(customerData?.name),
                  })
                : i18n.t('recommendationBottomSheet.sellAnywayCTA')}
            </BTN_LG>
          </Pressable>
        </Stack>
      )
    } else {
      return <></>
    }
  }

  return (
    <YStack>
      {showShareButton ? <RenderButton criteria={criteria as string} /> : <></>}
    </YStack>
  )
}

export default Footer
